import { render, staticRenderFns } from "./VistaColegios.vue?vue&type=template&id=6d95cc33&scoped=true&"
import script from "./VistaColegios.vue?vue&type=script&lang=js&"
export * from "./VistaColegios.vue?vue&type=script&lang=js&"
import style0 from "./VistaColegios.vue?vue&type=style&index=0&id=6d95cc33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d95cc33",
  null
  
)

export default component.exports